import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { from, map, Observable, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from '../api.service';

const QR_URL_HEADER = 'X-Diffusion-Qr-Url';

export interface DiffusionQr {
  readonly image: Blob;
  /** URL completa que codifica el QR. Null si el backend no expone el header (CORS). */
  readonly url: string | null;
}

@Injectable({ providedIn: 'root' })
export class DiffusionQrApiService {
  private readonly baseUrl = `${environment.api_server}/api`;

  constructor(
    private readonly http: HttpClient,
    private readonly api: ApiService,
  ) {}

  getDiffusionQr(eventId: number): Observable<DiffusionQr> {
    const url = `${this.baseUrl}/sellers/events/${eventId}/diffusion-qr`;
    return from(this.api.getAuthHeaders()).pipe(
      switchMap(headers =>
        this.http.get(url, { headers, observe: 'response', responseType: 'blob' })
      ),
      map(response => ({
        image: response.body as Blob,
        url: response.headers.get(QR_URL_HEADER),
      })),
    );
  }
}
